import React from 'react';
import gettext from '@eb/gettext';
import { Tabs } from '@eb/eds-tabs';
import { DiscoveryEventsFromView } from '../types';
import { EventRenderer } from './EventRenderer';
import { EventClient, EventClientProvider } from '@eb/event-renderer';

interface OrganizerEventsInternalProps {
    events: DiscoveryEventsFromView;
}

const eventClient = new EventClient();

export const OrganizerEvents: React.FunctionComponent<OrganizerEventsInternalProps> = (
    props,
) => {
    const { future_events, past_events, ...eventMetaData } = props.events;

    const upcomingEventsTabsItem = {
        displayName: `${gettext('Live Events')} ${
            eventMetaData.num_future_events || ''
        }`,
        content: (
            <section className="eds-l-pad-hor-2">
                <EventRenderer
                    eventMetaData={eventMetaData}
                    events={future_events}
                    type="future"
                />
            </section>
        ),
        value: 0,
    };

    const pastEventsTabsItem = {
        displayName: `${gettext('Past Events')} ${
            eventMetaData.num_past_events || ''
        }`,
        content: (
            <section className="eds-l-pad-hor-2">
                <EventRenderer
                    eventMetaData={eventMetaData}
                    events={past_events}
                    removeSaveHandlers={true}
                    type="past"
                />
            </section>
        ),
        value: 1,
    };

    return (
        <EventClientProvider client={eventClient}>
            <section className="organizer-events">
                <Tabs items={[upcomingEventsTabsItem, pastEventsTabsItem]} />
            </section>
        </EventClientProvider>
    );
};
